import { render, staticRenderFns } from "./CommonModel.vue?vue&type=template&id=650eaf60&scoped=true"
import script from "./CommonModel.vue?vue&type=script&lang=js"
export * from "./CommonModel.vue?vue&type=script&lang=js"
import style0 from "./CommonModel.vue?vue&type=style&index=0&id=650eaf60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650eaf60",
  null
  
)

export default component.exports